import { useLocation, useNavigate, useParams } from "react-router-dom";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";
import { updateBooking } from "../../../redux2/booking/bookingSlice";
import { getMyCompany } from "../../../redux2/user/userSlice";
import {
  DIRECT_PAYMENT,
  USER_ROLE_ENTERPRISE,
  WALLET_MINIMUM_AMOUNT,
} from "../../../common/constants";
import { getMyEnterprise } from "../../../redux2/enterprise/enterpriseSlice";
import { currencyType, getCarrierLogo } from "../../../utils/flightInfo";
import Loading from "../../Loading";
import convertNumbThousand from "../../../utils/convertNumbThousand";
import NcImage from "../../NcImage/NcImage";
import customTime from "../../../utils/customTime";
import { paymentMethods } from "../../../utils/paymentMethods";
import PaymentMethodsList from "../../PaymentMethods/PaymentMethodsList";
import ButtonPrimary from "../../Button/ButtonPrimary";
import CorporateList from "../../FlightBookingSteps/CorporateList";
import { issueAmadeusTicket } from "../Services/AmadeusApi";
import PassengerPriceAmadeus from "./PassengerPrice.amadeus";

const SettlePaymentAmadeus = ({ className = "" }) => {
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(false);
  const [paymentMethod, setPaymentMethod] = useState("wallet");
  const [selectedCorporate, setSelectedCorporate] = useState(null);
  const [showCorporateList, setShowCorporateList] = useState(false);
  const [payment, setPayment] = useState(null);

  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const query = new URLSearchParams(location.search);
  const adults = query.get("adults");
  const children = query.get("children");
  const infants = query.get("infants");
  const labors = query.get("labors");
  const passengerTypeState = query.get("passengerTypeState");

  const {
    reservation,
    charges,
    serviceCharge,
    systemFee,
    queryURL,
    rateDifference,
    amaClientRef,
    booking,
  } = location.state;

  const { company } = useSelector((state) => state.user);
  const { enterprise } = useSelector((state) => state.enterprise);
  const { user } = useSelector((state) => state.auth);

  const currency = "ETB";

  const { id } = useParams();

  useEffect(() => {
    dispatch(getMyCompany());
  }, [dispatch, id]);

  useEffect(() => {
    if (user?.role === USER_ROLE_ENTERPRISE) {
      dispatch(getMyEnterprise());
      setPaymentMethod("cbe_mobile");
    }

    if (
      company &&
      currencyType(currency) === "USD" &&
      company?.USDCreditLimit > totalPrice
    ) {
      setPaymentMethod("USDCredit");
    } else {
      setPaymentMethod("");
    }

    if (
      company &&
      company.wallet <
        (company?.ADMLimit || WALLET_MINIMUM_AMOUNT) +
          priceToNumber(totalPrice()) &&
      currencyType(currency) === "USD"
      // passengerTypeState !== NON_DOCUMENT_HOLDER
    ) {
      setPaymentMethod("cbe_mobile");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, user?.role, company]);

  const currentDate = new Date();

  const handleClick = async (otp) => {
    // e.preventDefault();

    if (
      company &&
      paymentMethod === "wallet" &&
      company.wallet <
        (company?.ADMLimit || WALLET_MINIMUM_AMOUNT) +
          priceToNumber(totalPrice())
    ) {
      toast.error(
        `You can't use wallet for payment. You don't have enough balance. Please use other payment method.`,
      );
      return;
    }

    if (!company && paymentMethod === "credit") {
      if (!selectedCorporate) {
        toast.error("Please select corporate");
        return;
      }
    }

    let issueAt = moment(currentDate).format("YYYY-MM-DDTHH:mm:ss");

    let data = {
      id,
      orderId: reservation?.id,
      amaClientRef: amaClientRef,
      payment: paymentMethod || "wallet",
      otp: otp || null,
      corporateName: selectedCorporate || null,
      userId: user?._id,
      companyId: company?._id,
      issuedAt: issueAt,
      amount: offer?.price?.total,
      currency: offer?.price?.currency,
    };

    const response = await issueAmadeusTicket(data, setLoading);

    if (response?.data?.errors) {
      setError(response?.data?.errors?.[0]?.message);
      return;
    }

    if (response?.data) {
      toast.success("Booking Successful");

      navigate(`/amadeus-confirm-ticket?${queryURL}`, {
        state: {
          ticket: response?.data,
          charges,
          serviceCharge,
          queryURL,
          currency,
          rateDifference,
          amaClientRef,
        },
      });
    }

    // setLoading(true);
    // getTicket(otp)
    //   .then((res) => {
    //     if (res.TicketFailureInfo) {
    //       console.log(res);
    //       setError(res?.TicketFailureInfo?._attributes?.Message);
    //       setLoading(false);
    //     } else {
    //       setLoading(false);
    //       toast.success("Booking Successful");

    //       navigate(`/airarabia-confirm-ticket/${id}?${queryURL}`, {
    //         state: {
    //           ticket: res,
    //           charges,
    //           serviceCharge,
    //           reservation,
    //           queryURL,
    //           currency,
    //           rateDifference,
    //         },
    //       });
    //       return;
    //     }
    //   })
    //   .catch((err) => {
    //     console.log(err);
    //     if (err?.response?.data?.message) {
    //       setError(err?.response?.data?.message);
    //     }
    //     setLoading(false);
    //   });
  };

  useEffect(() => {
    if (error) {
      toast.error(error);
      setError(null);
    }
  }, [error]);

  const handleWithoutPayment = (e) => {
    e.preventDefault();

    const data = {
      id,
      PNR: reservation?.pnr,
      payment: "none",
      paymentStatus: "pending",
      status: "pending",
      serviceCharge: charges !== 0 ? charges : serviceCharge,
      systemFee: systemFee,
    };

    dispatch(updateBooking(data));
    // toast.success("Booking Success");
    navigate("/");
  };

  const initiatePayment = async () => {};

  const handleCorporateSubmit = (selectedCorporate) => {
    setShowCorporateList(false);
    setSelectedCorporate(selectedCorporate);
  };

  if (loading) {
    return <Loading />;
  }

  function totalPrice() {
    const airPriceTotal = parseFloat(offer?.price?.total);

    let result =
      rateDifference > 1
        ? (airPriceTotal * rateDifference).toFixed(2)
        : airPriceTotal;

    result =
      parseFloat(result) +
      charges +
      parseFloat(serviceCharge || 0) +
      (booking?.commission || 0);

    return convertNumbThousand(result);
  }

  function priceToNumber(str) {
    let result = str?.toString().replace(/,/g, "");
    return +result;
  }

  const groupTravelerPricings = (travelerPricings = []) => {
    return travelerPricings.reduce((acc, item) => {
      const key = item.travelerType;

      if (!acc[key]) {
        acc[key] = {
          count: 0,
          price: item.price,
        };
      }

      acc[key].count += 1;
      return acc;
    }, {});
  };

  let instructions = [];
  if (payment?.paymentInstructionsAll) {
    instructions = payment?.paymentInstructionsAll;
  } else {
    instructions = payment?.paymentInstructions;
  }

  const offer = reservation?.flightOffers?.[0];
  const travelers = reservation?.travelers;
  const groupedPricings = groupTravelerPricings(offer?.travelerPricings);

  const renderInstructions = () => {
    return (
      <div className="p-6 mt-2 sm:space-y-1 sm:p-6 xl:px-8 xl:py-1">
        <div className="flex flex-col tracking-wider">
          {instructions?.map((item, index) => (
            <div key={index}>
              <h1 className="text-xl font-semibold text-center underline">
                {item?.type}
              </h1>
              <div key={index} className="flex items-start">
                <div className="flex flex-col">
                  {item?.instructions?.map((instruction, i) => (
                    <span
                      className="text-sm font-semibold text-neutral-900"
                      key={i}
                    >
                      {instruction}
                    </span>
                  ))}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  };

  const renderSidebar = () => {
    return (
      <div className="flex flex-col p-6 space-y-6 w-full shadow sm:rounded-2xl lg:border border-neutral-200 sm:space-y-1 sm:p-6 xl:px-8 xl:py-1">
        <div className="flex flex-col sm:flex-row sm:items-center">
          <div className="flex-shrink-0 w-full sm:w-40">
            {/* <div className="overflow-hidden rounded-2xl aspect-w-4 aspect-h-3 sm:aspect-h-4"> */}
            <NcImage src={getCarrierLogo(offer?.validatingAirlineCodes?.[0])} />
          </div>
          <div className="py-5 space-y-3 sm:px-5">
            <span className="text-lg font-semibold text-neutral-500">
              <h1>{offer?.validatingAirlineCodes?.[0]}</h1>
            </span>
            {offer?.itineraries?.map((itinerary, itineraryIndex) => (
              <div key={itineraryIndex}>
                {itinerary.segments?.map((segment, segmentIndex) => (
                  <div key={segmentIndex}>
                    <span className="text-lg font-semibold text-neutral-500 line-clamp-1">
                      <h1>
                        {segment.departure?.iataCode} -{" "}
                        {segment.arrival?.iataCode}
                      </h1>
                    </span>
                    <span className="block mt-1 text-base font-medium">
                      {moment(segment.departure?.at).format("DD MMM YYYY")} -{" "}
                      {moment(segment.arrival?.at).format("DD MMM YYYY")}
                    </span>
                    <span className="block mt-1 text-base font-medium">
                      {customTime(segment.departure?.at)} -{" "}
                      {customTime(segment.arrival?.at)}
                    </span>
                  </div>
                ))}
              </div>
            ))}

            <div className="flex flex-row justify-between">
              <span className="block text-sm text-neutral-500 dark:text-neutral-400">
                {parseInt(adults)} Adult
              </span>
              <span className="block text-sm text-neutral-500 dark:text-neutral-400">
                {children > 0 && children + " Children"}
              </span>
              <span className="block text-sm text-neutral-500 dark:text-neutral-400">
                {infants > 0 && infants + " Infants"}
              </span>
            </div>

            <div className="w-10 border-b border-neutral-200 dark:border-neutral-700"></div>
            {/* <StartRating /> */}
          </div>
        </div>
        <div className="flex flex-col space-y-4">
          <h3 className="text-2xl font-semibold">Price detail</h3>

          <div>
            {Object.entries(groupedPricings).map(([travelerType, data]) => (
              <div
                key={travelerType}
                className="flex justify-between items-center py-2 text-neutral-600"
              >
                <p>
                  {data.count} × {travelerType}
                </p>

                <p>
                  {data.price.currency}{" "}
                  {convertNumbThousand(
                    String(Number(data.price.total) * data.count),
                  )}
                </p>
              </div>
            ))}
          </div>
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>Service charge</span>
            <span>
              {charges !== 0 ? charges : serviceCharge} {currencyType(currency)}
            </span>
          </div>
          <div className="flex justify-between text-neutral-6000 dark:text-neutral-300">
            <span>Agent Fee</span>
            <span>
              {booking?.commission || 0} {currencyType(currency)}
            </span>
          </div>

          <div className="border-b border-neutral-200"></div>
          <div className="flex justify-between text-xl font-bold text-black">
            <span>Total Price</span>
            <span>
              {totalPrice()} {offer?.price?.currency}
            </span>
          </div>
        </div>
      </div>
    );
  };

  const renderMain = () => {
    return (
      <div className="flex flex-col px-5 space-y-8 w-full shadow sm:rounded-2xl sm:border border-neutral-200 dark:border-neutral-700 sm:p-6 xl:p-8">
        <h2 className="text-3xl font-semibold lg:text-4xl">
          Confirm and payment
        </h2>
        <div className="border-b border-neutral-200 dark:border-neutral-700"></div>
        <div>
          <div>
            <h3 className="text-2xl font-semibold">Traveler Information</h3>
          </div>
          <div className="flex flex-col mt-6 w-full rounded-3xl border divide-y shadow border-neutral-200 dark:border-neutral-700 sm:flex-row sm:divide-x sm:divide-y-0 divide-neutral-200">
            <div className="px-1 py-4 text-lg font-light md:mx-32 md:px-5">
              {travelers?.map((travel, index) => (
                <>
                  <h1 className="p-2 text-xl font-bold">
                    Passenger {index + 1}
                  </h1>
                  <div className="flex flex-row justify-between px-4 space-x-12">
                    <h1 className="">Name</h1>
                    <span className="text-neutral-500 dark:text-neutral-400">
                      {travel?.name?.firstName} {travel?.name?.lastName}
                    </span>
                    {/* </div> */}
                  </div>
                  <div className="flex flex-row justify-between px-4 py-2 space-x-6">
                    <h1 className="">Email</h1>
                    <h1 className="text-neutral-500 dark:text-neutral-400">
                      {travel?.contact?.emailAddress}{" "}
                    </h1>
                  </div>

                  <div className="flex flex-row justify-between px-4 py-2">
                    <h1 className="">PNR</h1>
                    <span className="text-neutral-500 dark:text-neutral-400">
                      {reservation?.associatedRecords?.[index]?.reference}
                    </span>
                  </div>
                  <div className="flex flex-row justify-between px-4 py-2">
                    <h1 className="">Seat</h1>
                    <span className="text-neutral-500 dark:text-neutral-400">
                      {/* {travel?.AirSeatAssignment?._attributes?.Seat ||
                          "Seat Not Selected"} */}

                      {travel?.AirSeatAssignment ? (
                        travel?.AirSeatAssignment instanceof Array ? (
                          travel?.AirSeatAssignment?.map((seat, index) => (
                            <span key={index}>{seat._attributes.Seat} </span>
                          ))
                        ) : (
                          <span>{travel?.seat}</span>
                        )
                      ) : (
                        <span>Seat Not Selected</span>
                      )}
                    </span>
                  </div>
                </>
              ))}
            </div>
          </div>
          {/* <div className="flex flex-col gap-4 p-4 mt-6 rounded-lg border border-neutral-200 bg-neutral-50 dark:bg-neutral-800 sm:grid-cols-3">
            <div>
              <p className="text-sm font-medium text-neutral-600">
                Payment Deadline
              </p>
              <p className="mt-1 font-semibold text-neutral-900">
                {reservation?.ticketing?.timeLimit
                  ? moment(reservation.ticketing.timeLimit).format(
                      "MMM DD, YYYY HH:mm"
                    )
                  : "N/A"}
              </p>
            </div>
            <div>
              <p className="text-sm font-medium text-neutral-600">Advisory</p>
              <p className="mt-1 text-base text-neutral-900">
                {reservation?.ticketing?.advisory || "—"}
              </p>
            </div>
          </div> */}
        </div>

        <div>
          {!payment?.paymentInstructions && (
            <PaymentMethodsList
              paymentMethod={paymentMethod}
              setPaymentMethod={setPaymentMethod}
              setShowCorporateList={setShowCorporateList}
              user={user}
              enterprise={enterprise}
              company={company}
              totalPrice={priceToNumber(totalPrice())}
              setSelectedCorporate={setSelectedCorporate}
              departureDate={
                offer?.itineraries?.[0]?.segments?.[0]?.departure?.at
              }
              passengerTypeState={passengerTypeState}
              currency={currency}
            />
          )}

          {!DIRECT_PAYMENT.includes(paymentMethod) && payment && (
            <div className="p-5 rounded-xl border border-black shadow">
              <h1 className="text-2xl text-center capitalize font bold">
                {paymentMethod}
              </h1>
              <div className="flex flex-wrap justify-between px-2">
                <h1 className="text-xl font-semibold">Your PNR code is:</h1>
                <button
                  className="px-2 py-1 text-white rounded-lg cursor-pointer bg-slate-300"
                  onClick={() => {
                    navigator.clipboard.writeText(
                      // airReservation._attributes.LocatorCode
                      payment.paymentReference,
                    );
                    toast.success("Payment Reference code copied to clipboard");
                  }}
                >
                  <h1 className="flex text-xl font-bold">
                    {payment.paymentReference}
                    {/* {airReservation._attributes.LocatorCode} */}
                    <button className="mx-2 hover:text-green-800 hover:rounded-full">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="none"
                        viewBox="0 0 24 24"
                        strokeWidth={1.5}
                        stroke="currentColor"
                        className="w-6 h-6"
                      >
                        <path
                          strokeLinecap="round"
                          strokeLinejoin="round"
                          d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z"
                        />
                      </svg>
                    </button>
                  </h1>
                </button>
              </div>
              {renderInstructions()}
            </div>
          )}
        </div>

        <h1 className="text-xl font-semibold">
          Selected Payment Method:{" "}
          <span className="text-main">
            {
              paymentMethods.find((method) => method.name === paymentMethod)
                ?.title
            }
          </span>
        </h1>

        {paymentMethod === "wallet" ||
        paymentMethod === "credit" ||
        paymentMethod === "USDCredit" ? (
          <>
            <div className="space-y-2 lg:hidden row lg:p-0">
              <div className="col-12">
                <ButtonPrimary className="py-3 w-full bg-red-500 hover:bg-red-400">
                  Cancel Booking
                </ButtonPrimary>
              </div>
              <div className="col-12">
                <ButtonPrimary
                  className="w-full text-white bg-gray-400 hover:bg-gray-300 disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={handleWithoutPayment}
                >
                  Continue Without Payment
                </ButtonPrimary>
              </div>
              <div className="col-12">
                <ButtonPrimary
                  onClick={() => handleClick()}
                  className="mb-3 w-full"
                >
                  Confirm and pay
                </ButtonPrimary>
              </div>
            </div>

            <div className="hidden gap-4 justify-between pt-8 lg:flex">
              {/* <div className="w-full">
                <ButtonPrimary className="py-3 w-44 bg-red-500 hover:bg-red-400">
                  Cancel Booking
                </ButtonPrimary>
              </div> */}
              <div className="w-full">
                <ButtonPrimary
                  className="w-full text-black rounded-3xl border-gray-500 bg-slate-50 border-1 hover:text-white hover:bg-gray-400 focus:outline-none focus:ring-2 focus:ring-main focus:ring-opacity-50 disabled:opacity-50 disabled:cursor-not-allowed"
                  onClick={handleWithoutPayment}
                >
                  {/* Continue Without Payment */}
                  Pay Later
                </ButtonPrimary>
              </div>
              <div className="w-full">
                <ButtonPrimary
                  onClick={() => handleClick()}
                  className="w-full text-black rounded-3xl border-1 border-main bg-slate-50 hover:text-white hover:bg-main-900 focus:outline-none focus:ring-2 focus:ring-main focus:ring-opacity-50"
                >
                  Confirm and pay
                </ButtonPrimary>
              </div>
            </div>
          </>
        ) : paymentMethod === "" ? (
          <div className="space-y-3 row lg:p-0">
            <div className="col-12">
              <ButtonPrimary
                className="w-full text-white bg-gray-400 hover:bg-gray-300"
                // onclick go home
                onClick={() => navigate("/")}
              >
                No Payment Method Selected
              </ButtonPrimary>
            </div>
          </div>
        ) : (
          <div className="space-y-3 row lg:p-0">
            <div className="col-12">
              <ButtonPrimary
                className="py-3 w-full bg-green-500 hover:bg-green-400"
                onClick={initiatePayment}
                // onClick={handleWithoutPayment}
              >
                Proceed
              </ButtonPrimary>
            </div>
          </div>
        )}
      </div>
    );
  };

  return (
    <div
      className={`px-1 py-4 nc-CheckOutPage ${className}`}
      data-nc-id="CheckOutPage"
    >
      <main className="flex flex-col-reverse mt-11 mb-24 lg:mx-24 lg:mb-32 lg:flex-row">
        <div className="w-full lg:w-3/5 xl:w-2/3 lg:pr-10">{renderMain()}</div>
        <div className="flex-grow mb-10 lg:block">{renderSidebar()}</div>
      </main>
      {paymentMethod === "credit" && (
        <CorporateList
          show={showCorporateList}
          handleClose={handleCorporateSubmit}
        />
      )}
    </div>
  );
};

export default SettlePaymentAmadeus;
